
        <mat-card class="m-2 p-1 h-100" fxLayout="column" >
            <mat-card-header style="min-height: 120px;">
                <mat-card-subtitle class="mb-3">
                    <form [formGroup]="form" autocomplete="nope">
                         <!-- {{diagnostic}}   -->
                        <mat-error *ngIf="error" class="alert alert-danger">{{error}}</mat-error>
                        <div class="w-100">
                            
                            <mat-form-field style="width: 110px" ngClass="ml-3">
                                <input matInput [matDatepicker]="startDatepicker" formControlName="start" (dateChange)="onDateChange($event)">
                                <mat-datepicker-toggle matSuffix [for]="startDatepicker"></mat-datepicker-toggle>
                                <mat-datepicker #startDatepicker></mat-datepicker>
                            </mat-form-field>

                            <mat-button-toggle-group name="fontStyle" aria-label="Font Style" class="weekNavigator_container">
                                <mat-button-toggle value="bold" (click)="navDay(-1)">{{ 'SCHEDULER.PREV-DAY' | translate }}</mat-button-toggle>
                                <mat-button-toggle value="italic" (click)="today()">{{ 'SCHEDULER.TODAY' | translate }}</mat-button-toggle>
                                <mat-button-toggle value="underline" (click)="navDay(1)">{{ 'SCHEDULER.NEXT-DAY' | translate }}</mat-button-toggle>
                              </mat-button-toggle-group>
                        </div>


                        <mat-form-field style="width:130px;" class="ml-3">
                            <mat-select placeholder="{{ 'SCHEDULER.SELECT-THERAPIST' | translate}}" formControlName="scheduler">
                                <mat-option>{{ 'SCHEDULER.SELECT-THERAPIST' | translate}}</mat-option>
                                <mat-option *ngFor="let schedulerItem of schedulers" [value]="schedulerItem.ID">
                                    {{ schedulerItem.Name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field style="width:130px;" class="ml-3">
                            <mat-select placeholder="{{ 'SCHEDULER.SELECT-PRACTICE' | translate}}" formControlName="practice">
                                <mat-option>{{ 'SCHEDULER.SELECT-PRACTICE' | translate}}</mat-option>
                                <mat-option *ngFor="let practiceItem of practices" [value]="practiceItem.ID">
                                    {{ practiceItem.Name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </form>
                </mat-card-subtitle>
            </mat-card-header>

            <mat-card-content  class="p-3" style="background-color: #F3F6FB; overflow-y: auto;min-height: 110px;">
                
                <mat-spinner *ngIf="show_loadingSpinner == true" color="accent"></mat-spinner>
                <p *ngIf="show_noDataLabel == true" fxLayoutAlign="center">{{ 'SCHEDULER.NO-DATA-FOUND' | translate}}</p>

                <div fxLayout="column" 
                     fxLayout.gt-sm="row wrap" 
                     fxLayoutAlign="start" 
                     class="flex-parent"                    
                     >
                    
                     <app-appointment #weeklyAppointments *ngFor="let currentAppointment of appointments" 
                     class="mb-3 ml-1 mr-1"
                     fxFlex="auto" 
                     fxFlex.gt-sm="calc(50%-24px)"
                     fxFlex.gt-md="calc(33.3%-24px)" fxLayoutAlign="stretch"  
                      [appointment]="currentAppointment"
                      (delete)="onDelete($event)"
                      (confirmed)="onConfirm($event)" 
                      (captureFile)="file.click()"
                      (uploadDocument)="onUploadDocumentClicked($event)"
                      (paymentRequest)="onPaymentRequest($event)"
                      (sendOrFillForm)="onSendOrFillForm($event)"
                      id="eventID_{{currentAppointment.EventID}}">
                    </app-appointment>
                </div>

            </mat-card-content>

        </mat-card>


        <!-- for IOS do not set display:none on the file element-->       
        <input #file type="file" multiple accept="image/*" multiple style="cursor: pointer; width:0; height:0;" (input)="onUploadImage($event)"/>
        <input #fileDocument  type="file" multiple accept=".doc,.docx,.pdf,.xsl,.xslx,.txt" multiple style="cursor: pointer; width:0; height:0;" (change)="onUploadDocument($event)"/>
        


